import { Link } from "react-router-dom";
import { ArrowUpRight, CheckIcon } from "@/components/icons";
import { initials, jobTitle, relativeDate } from "@/lib/format";
import type { JobSummary } from "@/lib/types";

const avatarTones = ["ink", "violet", "coral", "teal", "mustard"];

export function JobCard({ job, featured = false }: { job: JobSummary; featured?: boolean }) {
  const title = jobTitle(job);
  const tone = avatarTones[(job.company || "").length % avatarTones.length];
  const summary = job.job_description;

  return (
    <article className={`job-card ${featured ? "job-card--featured" : ""}`}>
      <Link className="job-card__hit" to={`/jobs/${encodeURIComponent(job.job_id)}`} reloadDocument aria-label={`${title} at ${job.company || "Employer"}`} />
      <div className="job-card__top">
        <div className={`company-avatar company-avatar--${tone}`}>{initials(job.company)}</div>
        <span className="job-card__arrow"><ArrowUpRight /></span>
      </div>
      <div className="job-card__body">
        <p className="job-card__company">{job.company || "Employer"}</p>
        <h3>{title}</h3>
        {summary ? <p className="job-card__summary">{summary}</p> : null}
      </div>
      <div className="job-card__meta">
        <div>
          {job.location ? <span>{job.location}</span> : null}
          {job.work_model ? <span>{job.work_model}</span> : null}
          {job.employment_type ? <span>{job.employment_type}</span> : null}
        </div>
        <p><CheckIcon /> {relativeDate(job.last_seen_date)}</p>
      </div>
    </article>
  );
}
